import { FenceZone, FenceZoneValue, SearchTypeIDs, SearchTypeValue } from '../../util/enums';
import { SearchType, ToolOrderByType, FenceZoneType } from './types';

export const SearchTypes: SearchType[] = [
  { id: SearchTypeIDs.ActiveAssets, value: SearchTypeValue.ActiveAssets },
  { id: SearchTypeIDs.Beacons, value: SearchTypeValue.Beacons },
  { id: SearchTypeIDs.Devices, value: SearchTypeValue.Devices },
  { id: SearchTypeIDs.GPSTrackers, value: SearchTypeValue.GPSTrackers },
  { id: SearchTypeIDs.Geofences, value: SearchTypeValue.Geofences, forEditing: true },
  { id: SearchTypeIDs.Locations, value: SearchTypeValue.Locations, forEditing: true },
  { id: SearchTypeIDs.Microfences, value: SearchTypeValue.Microfences, forEditing: true },
  { id: SearchTypeIDs.Tools, value: SearchTypeValue.Tools },
];

export const ToolOrderByTypes: ToolOrderByType[] = [
  { id: 'id', value: 'ID' },
  { id: 'label', value: 'Label' },
  { id: 'toolType', value: 'Tool Type' },
];

export const FenceZoneTypes: FenceZoneType[] = [
  { id: FenceZone.breach, value: FenceZoneValue.Breach },
  { id: FenceZone.buffer, value: FenceZoneValue.Buffer },
  { id: FenceZone.cleared, value: FenceZoneValue.Cleared },
  { id: FenceZone.none, value: FenceZoneValue.NoZone },
  { id: FenceZone.loading, value: FenceZoneValue.Loading },
  { id: FenceZone.dumping, value: FenceZoneValue.Dumping },
  { id: FenceZone.maintenance, value: FenceZoneValue.Maintenance },
];
